// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  font-size: 16px;
  margin: 16px 8px 0 12px;
  color: #3e5777;
  border-bottom: 1px solid #3e5777;
  padding-bottom: 2px;
}

.grid-row {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  justify-content: left;
}

.grid-cell-third {
  min-width: 31.333%;
  margin-left: 1%;
  margin-right: 1%;
  flex: auto;
}

.grid-cell-half {
  min-width: 48%;
  margin-left: 1%;
  margin-right: 1%;
  flex: auto;
}

.grid-cell-full {
  min-width: 98%;
  margin-left: 1%;
  margin-right: 1%;
  flex: auto;
}

.grid-cell-100 {
  width: 100%;
}

.field {
  width: 310px;
}

.photo {
  padding: 10px 10px 10px 0;
  float: left;
}

.offset-top {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/model/features2.mobile.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,uBAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,WAAA;AACJ;;AAEA;EACI,gBAAA;AACJ","sourcesContent":[".title {\n    font-size: 16px;\n    margin: 16px 8px 0 12px;\n    color: #3e5777;\n    border-bottom: 1px solid #3e5777;\n    padding-bottom: 2px;\n}\n\n.grid-row {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: left;\n}\n\n.grid-cell-third {\n    min-width: 31.333%;\n    margin-left: 1%;\n    margin-right: 1%;\n    flex: auto;\n}\n\n.grid-cell-half {\n    min-width: 48%;\n    margin-left: 1%;\n    margin-right: 1%;\n    flex: auto;\n}\n\n.grid-cell-full {\n    min-width: 98%;\n    margin-left: 1%;\n    margin-right: 1%;\n    flex: auto;\n}\n\n.grid-cell-100 {\n    width: 100%;\n}\n\n.field {\n    width: 310px;\n}\n\n.photo {\n    padding: 10px 10px 10px 0;\n    float: left;\n}\n\n.offset-top {\n    margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
